import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';

const buildUserUrl = (userId) => buildUrl(`/users/${userId}`);

export function getApiCallState(state, userId) {
  return ApiCall.find(state, { method: 'GET', url: buildUserUrl(userId) });
}

export function fetchUserIfNeeded(userId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildUserUrl(userId) })) {
      return false;
    }

    return dispatch(fetchUser(userId));
  };
}

export function fetchUser(userId) {
  return (dispatch) => {
    const url = buildUserUrl(userId);
    const method = 'GET';

    return dispatch(fetchUserRequest()).payload
      .then((response) => dispatch(fetchUserSuccess(response)))
      .catch((error) => dispatch(fetchUserFailure(error)));

    function fetchUserRequest() {
      return ApiCall.createAction({
        type: FETCH_USER_REQUEST,
        payload: fetch(url),
        url,
        method,
        userId,
        disableDefault: true,
      });
    }

    function fetchUserSuccess(user) {
      return ApiCall.createAction({
        type: FETCH_USER_SUCCESS,
        payload: user,
        url,
        method,
        userId,
      });
    }

    function fetchUserFailure(error) {
      return ApiCall.createAction({
        type: FETCH_USER_FAILURE,
        error,
        url,
        method,
        userId,
        disableDefault: true,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/Users/actions.js